import { RecipientRole } from 'database'

export const getRecipientCanHaveFields = <T extends { role: RecipientRole }>(
  recipient: T
) => recipient.role !== 'proxy' && recipient.role !== 'viewer'
